import React, {useEffect, useRef, useState} from 'react';
import {t} from 'react-switch-lang';
import './DownloadBtn.scss';
import {
  getReport,
  getReportErr,
} from '../../../../../services/reports/kriReport';
import Toast from '../../../../../components/toast/Toast';
import Swal from 'sweetalert2';
import {createXLSXFromBlob} from '../../../../../utils/const';
import Spinner from 'reactstrap/lib/Spinner';

const DownloadBtn = ({
  api,
  apiParameters,
  setIsSubmitted,
  paramsLength,
  isCustom,
  isDisabled=false,
  disableCheckingIfAllFilled=false
}) => {
  const [parameters, setParameters] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const isSubmittingRef = useRef(false);
  const checkIfAllFilled = () => {
    let message = true;
    if (Object.values(apiParameters).length !== paramsLength) {
      message = false;
    } else {
      Object.values(apiParameters).map((item) => {
        if (item.length === 0) {
          message = false;
        }
      });
    }

    if(disableCheckingIfAllFilled){
      message=true
    }

    return message;
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setTimeout(() => {
      isSubmittingRef.current = false;
    }, 1000);
    setIsSubmitted(true);
    if (checkIfAllFilled()) {
      setIsLoading(true);
      const newData = Object.values(parameters)
        .filter(item => typeof item === 'string' && item?.length > 0)
        .join('&');
      getReport(api, newData, isCustom)
        .then((r) => {
          Toast.fire({
            icon: 'success',
            title: `${t('message.successDownloadReport')}`,
          });
          setIsLoading(false);
          const contentDisposition = r.headers['content-disposition']
            .split(';')
            .find((element) => element.includes('filename'));

          const fileName = decodeURIComponent(
            contentDisposition.split("'").pop()
          );

          createXLSXFromBlob(r.data, fileName);

          setIsSubmitted(false);
        })
        .catch((r) => {
          getReportErr(api, newData, isCustom)
            .then((r) => {
              setIsLoading(false);
              setIsSubmitted(false);
            })
            .catch((r) => {
              setIsLoading(false);
              setIsSubmitted(false);
              if (r.response.status === 403) {
                Swal.fire({
                  text: `${t('message.permission')}`,
                  icon: 'error',
                  confirmButtonText: 'OK',
                });
              } else if (r.response.data.code === 'report-no-result') {
                Swal.fire({
                  text: `${t('message.report-no-result')}`,
                  icon: 'error',
                  confirmButtonText: 'OK',
                });
              } else if (r.response.data.code === 'department-list-is-empty') {
                Swal.fire({
                  text: `${t('message.department-list-is-empty')}`,
                  icon: 'error',
                  confirmButtonText: 'OK',
                });
              } else {
                Swal.fire({
                  text: `${t('message.errorApi')}`,
                  icon: 'error',
                  confirmButtonText: 'OK',
                });
              }
            });
        });
    }
  };

  useEffect(() => {
    setParameters(apiParameters);
  }, [apiParameters]);

  return (
    <>
      <button disabled={isDisabled} className="report-button" onClick={(e) => handleClick(e)}>
        {t('reports.btnDownload')}
        {isLoading && <Spinner animation="border" size="sm" className="ml-2" />}
      </button>
    </>
  );
};

export default DownloadBtn;
